import { TM_FRAUD_SOURCE_IDS } from './GlobalConstant';
import { getStrategyType } from './localStorageUtils';
import { getSelectedResources } from './resourceManager';

const { tmResources } = getSelectedResources();

export const returnFraudUserAccess = (authenticationData) => {
  // declare bool variables
  let isFraud = false;
  let isTMuser = false;

  // loop through the authentication data for the necessary flagging
  authenticationData.forEach((data) => {
    let scopes = data.details?.resource?.operations
      ? data.details.resource.operations
      : [];
    if (scopes.includes(tmResources.APP_3_RESOURCE_UI_TM_IAD_FULLACCESS)) {
      data.attributes.forEach((attribute) => {
        if (
          attribute.attributeValues.includes(TM_FRAUD_SOURCE_IDS.TM) &&
          attribute.attributeValues.includes(TM_FRAUD_SOURCE_IDS.FRAUD)
        ) {
          isFraud = true;
          isTMuser = true;
        } else if (attribute.attributeValues.includes(TM_FRAUD_SOURCE_IDS.TM)) {
          isTMuser = true;
        } else if (
          attribute.attributeValues.includes(TM_FRAUD_SOURCE_IDS.FRAUD)
        ) {
          isFraud = true;
        }
      });
    }
  });

  return {
    isTMuser,
    isFraud
  };
};

export const returnFraudUserAccessByResource = (
  authenticationData,
  resourceCode
) => {
  // declare bool variables
  let isFraud = false;
  let isFraudPrevention = false;
  let isTMuser = false;
  let isRTUser = false;

  // loop through the authentication data for the necessary flagging
  authenticationData.forEach((data) => {
    const strategyType = getStrategyType();
    let accessCode;
    if (strategyType === 'keycloak') {
      accessCode = data.details.resource.operations.includes(resourceCode)
        ? resourceCode
        : undefined;
    } else {
      accessCode = data.details.resource.resourceCode;
    }

    if (accessCode === resourceCode) {
      data.attributes.forEach((attribute) => {
        if (attribute.attributeValues.includes(TM_FRAUD_SOURCE_IDS.TM)) {
          isTMuser = true;
        }
        if (attribute.attributeValues.includes(TM_FRAUD_SOURCE_IDS.FRAUD)) {
          isFraud = true;
        }
        if (
          attribute.attributeValues.includes(TM_FRAUD_SOURCE_IDS.FRAUD_PREV_ID)
        ) {
          isFraudPrevention = true;
          isRTUser = true;
        }
      });
    }
  });

  return {
    isTMuser,
    isFraud,
    isFraudPrevention,
    isRTUser
  };
};
